const moment = require('moment');

export function arrayToMatrix(list, elementsPerSubArray) {
  var matrix = [],
    i,
    k;

  for (i = 0, k = -1; i < list.length; i++) {
    if (i % elementsPerSubArray === 0) {
      k++;
      matrix[k] = [];
    }

    matrix[k].push(list[i]);
  }

  return matrix;
}

export function getOperatingSystem() {
  var OSName = 'Unknown OS';
  if (navigator.appVersion.indexOf('Win') != -1) OSName = 'Windows';
  if (navigator.appVersion.indexOf('Mac') != -1) OSName = 'MacOS';
  if (navigator.appVersion.indexOf('X11') != -1) OSName = 'UNIX';
  if (navigator.appVersion.indexOf('Linux') != -1) OSName = 'Linux';
  return OSName;
}

export function isDateValid(dateStr) {
  return (
    typeof dateStr === 'string' && moment(dateStr, 'YYYY-MM-DD', true).isValid()
  );
}

export function hasDecimalNumbers(value) {
  if (typeof value !== 'number') {
    return false;
  }

  const isDecimal = !Number.isInteger(value);  
  return isDecimal
}

export function getCompetitionYear (date) {
  const d = (date && moment(date).isValid()) ? moment(date) : moment();
  const result = d.month() <= 10 ? d.year() : d.year() + 1;
  return result;
};